// extracted by mini-css-extract-plugin
module.exports = {"tick":"ToolTip_tick__2Cb13","tooltip":"ToolTip_tooltip__3SFuP","small":"ToolTip_small__3qVCc"};